export const TrustValue = (value: unknown): boolean => {
  return value !== undefined && value !== null;
};
